<div id="data-model-prefs">
  <nb-accordion>
    <nb-accordion-item>
      <nb-accordion-item-header>
        {{ "category_icon_update"| translation }}
      </nb-accordion-item-header>
      <nb-accordion-item-body>
        <cat-config></cat-config>
      </nb-accordion-item-body>
    </nb-accordion-item>
  </nb-accordion>

  <nb-accordion>
    <nb-accordion-item>
      <nb-accordion-item-header>
        {{ "category_new"| translation }}
      </nb-accordion-item-header>
      <nb-accordion-item-body>
        <app-new-data-category></app-new-data-category>
      </nb-accordion-item-body>
    </nb-accordion-item>
  </nb-accordion>

  <nb-accordion>
    <nb-accordion-item>
      <nb-accordion-item-header>
        {{ "data_type_update"| translation }}
      </nb-accordion-item-header>
      <nb-accordion-item-body>
        <app-type-config></app-type-config>
      </nb-accordion-item-body>
    </nb-accordion-item>
  </nb-accordion>

  <nb-accordion>
    <nb-accordion-item>
      <nb-accordion-item-header>
        {{ "data_type_new"| translation }}
      </nb-accordion-item-header>
      <nb-accordion-item-body>
        <app-new-data-model></app-new-data-model>
      </nb-accordion-item-body>
    </nb-accordion-item>
  </nb-accordion>


  <nb-accordion>
    <nb-accordion-item>
      <nb-accordion-item-header>
        {{ "configuration_updates"| translation }}
      </nb-accordion-item-header>
      <nb-accordion-item-body>
        <app-data-config-update></app-data-config-update>

      </nb-accordion-item-body>
    </nb-accordion-item>
  </nb-accordion>
</div>
